import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { getLink } from '../../utils';
import { ImageModalCircleCactus } from '../assets/ImageModalCircleCactus';

export function PreRegisterModal() {
  const { t } = useTranslation('modais');
  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.PRE_REGISTER)
  }

  function handleFirstAccessRedirect () {
    window.location.href = getLink('recuperar/senha');
  }
  
  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.PRE_REGISTER)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalCircleCactus />
            </div>
            <p className="modal-title">
              Ainda não tem senha?
            </p>

            <div className="smls-modal-text modal-first-access-content modal-subtitle">
              <p className='modal-first-access-introduction'>
                Se você não lembra a senha cadastrada ou esse é o seu
                <br />
                primeiro acesso, é necessário criar uma senha. Vamos lá?
              </p>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <SmlsButton text={t('first_access_modal.already_has_password_button')} color="hyperlink" onClick={toggleModal} />
        <SmlsButton text='Criar senha' className="button" onClick={handleFirstAccessRedirect} />
      </ModalFooter>
    </SmlsModal>
  );
}
